export enum ArchiveType {
  All = 0,
  Calls = 1,
  Chat = 5
}

export enum RecordStatusType {
  Valid = 0,
  Cancelled = 1,
  Expired = 2
}
